import i18n from '@/locale'
import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/index.vue'
import store from '@/store'
import { maxTabs } from '@/config'

Vue.use(VueRouter)
export const constantRoutes = [
  {
    path: '/',
    component: Layout,
    redirect: 'index',
    children: [
      {
        path: '/index',
        name: 'Index',
        component: () => import('@/views/home/index.vue'),
        meta: { title: i18n.t('首页'), affix: true },
      },
    ],

    meta: { title: i18n.t('首页'), hidden: true },
  },
  /*{
    path: '/authorityMng',
    component: Layout,
    children: [
      {
        path: '/roleMng',
        name: 'roleMng',
        component: () => import('@/views/authorityMng/roleMng/index.vue'),
        meta: { title: '角色管理', buttons: [] },
      },
      {
        path: '/menuMng',
        name: 'menuMng',
        component: () => import('@/views/authorityMng/menuMng/index.vue'),
        meta: { title: '菜单管理', buttons: [] },
      },
      {
        path: '/userManagement',
        name: 'userManagement',
        component: () => import('@/views/authorityMng/userManagement/index.vue'),
        meta: { title: '用户管理', buttons: [] },
      },
    ],
    meta: { title: '权限管理' },
  },*/
  /*{
    path: '/article',
    component: Layout,
    meta: {
      title: '内容',
    },
    children: [
      {
        path: '/article',
        name: 'ArticleList',
        component: () => import('@/views/article'),
        meta: {
          title: '主推新品图',
          buttons: [
            { path: 'add' },
            { path: 'edit' },
            { path: 'detail' },
            { path: 'enable' },
            { path: 'disable' },
            { path: 'remove' },
          ],
        },
      },
      {
        path: '/article/add',
        name: 'ArticleAdd',
        component: () => import('@/views/article/components/add'),
        meta: {
          hidden: true,
          title: '新增主推新品图',
        },
      },
      {
        path: '/article/edit/:id',
        name: 'ArticleEdit',
        component: () => import('@/views/article/components/edit'),
        meta: {
          hidden: true,
          title: '编辑主推新品图',
        },
      },
      {
        path: '/article/detail/:id',
        name: 'ArticleDetail',
        component: () => import('@/views/article/components/detail'),
        meta: {
          hidden: true,
          title: '主推新品图详情',
        },
      },
      {
        path: '/newIPCooperation',
        name: 'NewIPCooperationList',
        component: () => import('@/views/newIPCooperation'),
        meta: {
          title: '新IP合作官宣',
          buttons: [
            { path: 'add' },
            { path: 'edit' },
            { path: 'detail' },
            { path: 'enable' },
            { path: 'disable' },
            { path: 'remove' },
          ],
        },
      },
      {
        path: '/newIPCooperation/add',
        name: 'NewIPCooperationAdd',
        component: () => import('@/views/newIPCooperation/components/add'),
        meta: {
          hidden: true,
          title: '新增新IP合作官宣',
        },
      },
      {
        path: '/newIPCooperation/edit/:id',
        name: 'NewIPCooperationEdit',
        component: () => import('@/views/newIPCooperation/components/edit'),
        meta: {
          hidden: true,
          title: '编辑新IP合作官宣',
        },
      },
      {
        path: '/newIPCooperation/detail/:id',
        name: 'NewIPCooperationDetail',
        component: () => import('@/views/newIPCooperation/components/detail'),
        meta: {
          hidden: true,
          title: '新IP合作官宣详情',
        },
      },

      {
        path: '/shopOverview',
        name: 'ShopOverviewList',
        component: () => import('@/views/shopOverview'),
        meta: {
          title: '精选新店图',
          buttons: [
            { path: 'add' },
            { path: 'edit' },
            { path: 'detail' },
            { path: 'enable' },
            { path: 'disable' },
            { path: 'remove' },
          ],
        },
      },
      {
        path: '/shopOverview/add',
        name: 'ShopOverviewAdd',
        component: () => import('@/views/shopOverview/components/add'),
        meta: {
          hidden: true,
          title: '新增精选新店图',
        },
      },
      {
        path: '/shopOverview/edit/:id',
        name: 'ShopOverviewEdit',
        component: () => import('@/views/shopOverview/components/edit'),
        meta: {
          hidden: true,
          title: '编辑精选新店图',
        },
      },
      {
        path: '/shopOverview/detail/:id',
        name: 'ShopOverviewDetail',
        component: () => import('@/views/shopOverview/components/detail'),
        meta: {
          hidden: true,
          title: '精选新店图详情',
        },
      },

      {
        path: '/ourGlobalVision',
        name: 'OurGlobalVisionList',
        component: () => import('@/views/ourGlobalVision'),
        meta: {
          title: '全球化战略内容',
          buttons: [
            { path: 'add' },
            { path: 'edit' },
            { path: 'detail' },
            { path: 'enable' },
            { path: 'disable' },
            { path: 'remove' },
          ],
        },
      },
      {
        path: '/ourGlobalVision/add',
        name: 'OurGlobalVisionAdd',
        component: () => import('@/views/ourGlobalVision/components/add'),
        meta: {
          hidden: true,
          title: '新增全球化战略内容',
        },
      },
      {
        path: '/ourGlobalVision/edit/:id',
        name: 'OurGlobalVisionEdit',
        component: () => import('@/views/ourGlobalVision/components/edit'),
        meta: {
          hidden: true,
          title: '编辑全球化战略内容',
        },
      },
      {
        path: '/ourGlobalVision/detail/:id',
        name: 'OurGlobalVisionDetail',
        component: () => import('@/views/ourGlobalVision/components/detail'),
        meta: {
          hidden: true,
          title: '全球化战略内容详情',
        },
      },

      {
        path: '/news',
        name: 'NewsList',
        component: () => import('@/views/news'),
        meta: {
          title: '品牌大事件新闻',
          buttons: [
            { path: 'add' },
            { path: 'edit' },
            { path: 'detail' },
            { path: 'enable' },
            { path: 'disable' },
            { path: 'remove' },
          ],
        },
      },
      {
        path: '/news/add',
        name: 'NewsAdd',
        component: () => import('@/views/news/components/add'),
        meta: {
          hidden: true,
          title: '新增品牌大事件新闻',
        },
      },
      {
        path: '/news/edit/:id',
        name: 'NewsEdit',
        component: () => import('@/views/news/components/edit'),
        meta: {
          hidden: true,
          title: '编辑品牌大事件新闻',
        },
      },
      {
        path: '/news/detail/:id',
        name: 'NewsDetail',
        component: () => import('@/views/news/components/detail'),
        meta: {
          hidden: true,
          title: '品牌大事件新闻详情',
        },
      },
      {
        path: '/ourStores',
        name: 'OurStoresList',
        component: () => import('@/views/ourStores'),
        meta: {
          title: '我们的门店',
          buttons: [
            { path: 'add' },
            { path: 'edit' },
            { path: 'detail' },
            { path: 'enable' },
            { path: 'disable' },
            { path: 'remove' },
          ],
        },
      },
      {
        path: '/ourStores/add',
        name: 'OurStoresAdd',
        component: () => import('@/views/ourStores/components/add'),
        meta: {
          hidden: true,
          title: '新增我们的门店',
        },
      },
      {
        path: '/ourStores/edit/:id',
        name: 'OurStoresEdit',
        component: () => import('@/views/ourStores/components/edit'),
        meta: {
          hidden: true,
          title: '编辑我们的门店',
        },
      },
      {
        path: '/ourStores/detail/:id',
        name: 'OurStoresDetail',
        component: () => import('@/views/ourStores/components/detail'),
        meta: {
          hidden: true,
          title: '我们的门店详情',
        },
      },

      {
        path: '/joinOurTeam',
        name: 'JoinOurTeamList',
        component: () => import('@/views/joinOurTeam'),
        meta: {
          title: '招聘投递',
          buttons: [
            { path: 'add' },
            { path: 'edit' },
            { path: 'detail' },
            { path: 'enable' },
            { path: 'disable' },
            { path: 'remove' },
          ],
        },
      },
      {
        path: '/joinOurTeam/add',
        name: 'JoinOurTeamAdd',
        component: () => import('@/views/joinOurTeam/components/add'),
        meta: {
          hidden: true,
          title: '新增招聘投递',
        },
      },
      {
        path: '/joinOurTeam/edit/:id',
        name: 'JoinOurTeamEdit',
        component: () => import('@/views/joinOurTeam/components/edit'),
        meta: {
          hidden: true,
          title: '编辑招聘投递',
        },
      },
      {
        path: '/joinOurTeam/detail/:id',
        name: 'JoinOurTeamDetail',
        component: () => import('@/views/joinOurTeam/components/detail'),
        meta: {
          hidden: true,
          title: '招聘投递详情',
        },
      },

      {
        path: '/carousel',
        name: 'CarouselList',
        component: () => import('@/views/carousel'),
        meta: {
          title: '轮播管理',
          buttons: [
            { path: 'add' },
            { path: 'edit' },
            { path: 'detail' },
            { path: 'enable' },
            { path: 'disable' },
            { path: 'remove' },
          ],
        },
      },

      {
        path: '/carousel/add',
        name: 'CarouselAdd',
        component: () => import('@/views/carousel/components/add'),
        meta: {
          hidden: true,
          title: '新增轮播',
        },
      },
      {
        path: '/carousel/edit/:id',
        name: 'CarouselEdit',
        component: () => import('@/views/carousel/components/edit'),
        meta: {
          hidden: true,
          title: '编辑轮播',
        },
      },
      {
        path: '/carousel/detail/:id',
        name: 'CarouselDetail',
        component: () => import('@/views/carousel/components/detail'),
        meta: {
          hidden: true,
          title: '轮播详情',
        },
      },
      {
        path: '/dictionary',
        name: 'DictionaryList',
        component: () => import('@/views/dictionary'),
        meta: {
          title: '字典管理',
          buttons: [
            { path: 'add' },
            { path: 'edit' },
            { path: 'detail' },
            { path: 'enable' },
            { path: 'disable' },
            { path: 'remove' },
          ],
        },
      },
    ],
  },*/
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
    meta: { title: i18n.t('登录'), hidden: true },
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/404.vue'),
    meta: { title: '404', hidden: true },
  },
  {
    path: '/401',
    name: '401',
    component: () => import('@/views/401.vue'),
    meta: { title: '401', hidden: true },
  },
]

// 开发环境下，添加一些本地用于模拟测试的路由
// if (process.env.NODE_ENV === 'development') {
//   const mockRoutes = require('../../test/routes.js').default
//   constantRoutes.push(...mockRoutes)
// }

function createRouter() {
  return new VueRouter({
    routes: constantRoutes,
  })
}
const router = createRouter()

export function resetRouter() {
  router.matcher = createRouter().matcher
}

const originalPush = router.push
router.push = function (...args) {
  const location = this.match(args[0])
  const visiteRoutes = store.getters['tabsBar/visiteRoutes']
  const target = visiteRoutes.find((item) => item.path === location.path)
  if (!target && visiteRoutes?.length > maxTabs) {
    const message = i18n.t('最多只能打开{slot1}个页面，请先关闭部分页面。是否关闭前五个页面？', { slot1: maxTabs + 1 })
    Vue.prototype
      .$mgAlert(message, i18n.t('提示'), { confirmButtonText: i18n.t('关闭并打开新页面') })
      .then(() => {
        const changePages = store.getters['tabsBar/changePages']
        if (visiteRoutes.some((item) => changePages.includes(item?.name))) {
          return Vue.prototype.$mgConfirm(i18n.t('当前页面正在编辑，确认关闭?'))
        }
      })
      .then(() => {
        visiteRoutes.slice(1, 5).forEach((route) => store.dispatch('tabsBar/removeTab', route))
        originalPush.call(this, ...args)?.catch(() => {})
      })
    return
  }
  return originalPush.call(this, ...args)?.catch(() => {})
}

export default router
